import _ from 'lodash'
import router from './../../router'
import API from './../../api'
import AuthUser from './../../auth'
import FB from './../../fb';

const DEFAULT_SERVER_SIDE_RESPONSE = {
  "hasResponse": false,
  "responseType": '',
  "header": "",
  "message": ""
};

const DEFAULT_LOGIN_FORM = {
  email: "",
  emailValidation: "",
  password: "",
  passwordValidation: "",
};

const DEFAULT_SIGN_UP_FORM = {
  name: "",
  nameValidation: "",
  email: "",
  emailValidation: "",
  password: "",
  passwordValidation: "",
};

const DEFAULT_FORGOT_PASSWORD_FORM = {
  email: "",
  emailValidation: "",
};

const DEFAULT_RESET_PASSWORD_FORM = {
  password: "",
  passwordValidation: "",
};

export default {
  namespaced: true,
  state: {
    user: AuthUser.getAuthUser(),
    serverSideResponse: _.clone(DEFAULT_SERVER_SIDE_RESPONSE),
    loginForm: _.clone(DEFAULT_LOGIN_FORM),
    signUpForm: _.clone(DEFAULT_SIGN_UP_FORM),
    forgotPasswordForm: _.clone(DEFAULT_FORGOT_PASSWORD_FORM),
    resetPasswordForm: _.clone(DEFAULT_RESET_PASSWORD_FORM),
    userNotifications: {
      notificationAll: true,
      notificationMarket: true,
      notificationProperties: true,
    }
  },
  mutations: {
    setLoginForm (state, form) {
      state.loginForm = _.merge(state.loginForm, form);
    },

    setSignUpForm (state, form) {
      state.signUpForm = _.merge(state.signUpForm, form);
    },

    setUserNotifications (state, userNotifications) {
      state.userNotifications = userNotifications;
    },

    setForgotPasswordForm (state, form) {
      state.forgotPasswordForm = _.merge(state.forgotPasswordForm, form);
    },

    setResetPasswordForm (state, form) {
      state.resetPasswordForm = _.merge(state.resetPasswordForm, form);
    },

    resetLoginForm (state) {
      state.serverSideResponse = _.clone(DEFAULT_SERVER_SIDE_RESPONSE);
      state.loginForm = _.clone(DEFAULT_LOGIN_FORM);
    },

    resetSignUpForm (state) {
      state.serverSideResponse = _.clone(DEFAULT_SERVER_SIDE_RESPONSE);
      state.signUpForm = _.clone(DEFAULT_SIGN_UP_FORM);
    },

    setServerSideResponse(state, serverSideResponse) {
      state.serverSideResponse = serverSideResponse;
    },

    /**
     * Set User
     * @param state
     * @param user
     */
    setUser (state, user) {
      state.user = user
    },
  },

  actions: {
    errorHandling: async ({ commit }, serverResponse) => {
      switch (serverResponse.data.key) {
        case "are-u-bot":
          commit('setServerSideResponse', {
            "hasResponse": true,
            "responseType": 'danger',
            "header": "Are you a bot?",
            "message": "bot-message"
          });
          break;
        case "account-exists":
          commit('setServerSideResponse', {
            "hasResponse": true,
            "responseType": 'warning',
            "header": "Token has been expired",
            "message": "password-reset-token-expired"
          });
          break;
        default:
          commit('setServerSideResponse', {
            "hasResponse": true,
            "responseType": 'danger',
            "header": "oops",
            "message": "request-failed",
          });
          break;
      }
    },

    login: async ({ commit, state }, redirect) => {
      let finalRedirect = redirect || '/dashboard';

      try {
        let email = state.loginForm.email;
        let password = state.loginForm.password;
        if (_.isEmpty(email)) {
          commit("setLoginForm", {
            "emailValidation": "is-invalid"
          });
          return false;
        }

        if (_.isEmpty(password)) {
          commit("setLoginForm", {
            "passwordValidation": "is-invalid"
          });
          return false;
        }

        commit('setLoading', true, { root: true })

        const jwt = await API.login(email, password)
        commit('setLoading', false, { root: true })

        let authUser = AuthUser.getAuthUser(jwt);
        commit('setUser', authUser)
        if (authUser['lang']) {
          AuthUser.setLocale(authUser['lang']);
        }

        await router.push({path: finalRedirect})
      } catch (e) {
        await commit('setLoading', false, { root: true })
        switch (e.response.data.key) {
          case "are-u-bot":
            commit('setServerSideResponse', {
              "hasResponse": true,
              "responseType": 'danger',
              "header": "Are you a bot?",
              "message": "bot-message"
            });
            break;
          default:
            commit('setServerSideResponse', {
              "hasResponse": true,
              "responseType": 'danger',
              "header": "Unable to login",
              "message": "unable-to-login"
            });
            break;
        }
      }
    },

    signUp: async ({ commit, state }, redirect) => {
      let finalRedirect = redirect || '/dashboard';
      try {
        let name = state.signUpForm.name;
        let email = state.signUpForm.email;
        let password = state.signUpForm.password;

        if (_.isEmpty(name)) {
          commit("setSignUpForm", {
            "nameValidation": "is-invalid"
          });
          return false;
        }
        commit("setSignUpForm", {
          "nameValidation": "is-valid"
        });


        if (_.isEmpty(email)) {
          commit("setSignUpForm", {
            "emailValidation": "is-invalid"
          });
          return false;
        }
        commit("setSignUpForm", {
          "emailValidation": "is-valid"
        });

        if (_.isEmpty(password) || password.length < 6) {
          commit("setSignUpForm", {
            "passwordValidation": "is-invalid"
          });
          return false;
        }
        commit("setSignUpForm", {
          "passwordValidation": "is-valid"
        });

        commit('setLoading', true, { root: true })

        const jwt = await API.signUp(name, email, password)
        commit('setLoading', false, { root: true })

        let authUser = AuthUser.getAuthUser(jwt);
        commit('setUser', authUser)

        if (authUser['lang']) {
          AuthUser.setLocale(authUser['lang']);
        }

        await router.push({path: finalRedirect})
      } catch (e) {
        await commit('setLoading', false, { root: true })
        switch (e.response.data.key) {
          case "are-u-bot":
            commit('setServerSideResponse', {
              "hasResponse": true,
              "responseType": 'danger',
              "header": "Are you a bot?",
              "message": "bot-message"
            });
            break;
          case "account-exists":
            commit('setServerSideResponse', {
              "hasResponse": true,
              "responseType": 'warning',
              "header": "Account already exists",
              "message": "account-exists"
            });
            break;
          default:
            commit('setServerSideResponse', {
              "hasResponse": true,
              "responseType": 'danger',
              "header": "Unable to login",
              "message": "unable-to-login"
            });
            break;
        }
      }
    },

    forgotPassword: async ({ commit, state }) => {
      try {
        let email = state.forgotPasswordForm.email;
        if (_.isEmpty(email)) {
          commit("setForgotPasswordForm", {
            "emailValidation": "is-invalid"
          });
          return false;
        }
        commit("setForgotPasswordForm", {
          "emailValidation": "is-valid"
        });

        commit('setLoading', true, { root: true })
        await API.forgotPassword(email)
        commit('setLoading', false, { root: true })

        commit('setServerSideResponse', {
          "hasResponse": true,
          "responseType": 'success',
          "header": "Reset password successful",
          "message": "reset-your-password-email-sent",
        });
      } catch (e) {
        await commit('setLoading', false, { root: true })
        switch (e.response.data.key) {
          case "are-u-bot":
            commit('setServerSideResponse', {
              "hasResponse": true,
              "responseType": 'danger',
              "header": "Are you a bot?",
              "message": "bot-message"
            });
            break;
          default:
            commit('setServerSideResponse', {
              "hasResponse": true,
              "responseType": 'danger',
              "header": "oops",
              "message": "request-failed",
            });
            break;
        }
      }
    },

    resetPassword: async ({ commit, state, dispatch }, token) => {
      try {
        let password = state.resetPasswordForm.password;
        if (_.isEmpty(password) || password.length < 6) {
          commit("setResetPasswordForm", {
            "passwordValidation": "is-invalid"
          });
          return false;
        }
        commit("setResetPasswordForm", {
          "passwordValidation": "is-valid"
        });

        commit('setLoading', true, { root: true })

        await API.resetPassword(token, password);
        commit('setLoading', false, { root: true })

        commit('setServerSideResponse', {
          "hasResponse": true,
          "responseType": 'success',
          "header": "Password changed successful",
          "message": "password-reset-success",
        });
      } catch (e) {
        await commit('setLoading', false, { root: true })
        await dispatch("errorHandling", e.response);
      }
    },

    goToLogin: async ({ commit }) => {
      commit('setServerSideResponse', DEFAULT_SERVER_SIDE_RESPONSE);
      await router.push({name: 'login'})
    },

    logout: async ({ commit }) => {
      AuthUser.removeAuthUser();
      commit('setUser', {});
      await router.push({name: 'home'})
    },

    getUserNotificationSettings: async ({ commit }, emailToken = null) => {
      let notificationSettings = null;
      try {
        if (emailToken) {
          notificationSettings = await API.getUserNotificationSettingsToken(emailToken);
        } else {
          notificationSettings = await API.getUserNotificationSettings();
        }

        commit('setUserNotifications', notificationSettings);
      } catch (e) {
        await router.push("/users/login");
      }
    },

    toggleNotification: async ({ commit, state }, payload) => {
        let userNotifications = state.userNotifications;
        userNotifications[payload.key] = payload.value;
        commit('setUserNotifications', userNotifications);

        if (payload._mnsc) {
          await API.updateUserNotificationByToken(payload.key, payload.value, payload._mnsc);
        } else {
          await API.updateUserNotification(payload.key, payload.value);
        }
    },

    logInWithFacebook: async ({ commit }, redirect) => {
      let finalRedirect = redirect || '/dashboard';

      try {
        let response = await FB.login();
        if (response && response.authResponse) {
          commit('setLoading', true, {root: true})
          const jwt = await API.fbLogin(response.authResponse.userID, response.authResponse.accessToken);
          commit('setLoading', false, {root: true})
          let authUser = AuthUser.getAuthUser(jwt);
          commit('setUser', authUser)
          if (authUser['lang']) {
            AuthUser.setLocale(authUser['lang']);
          }

          await router.push({path: finalRedirect})
        } else {
          commit('setLoading', false, {root: true})
          commit('setServerSideResponse', {
            "hasResponse": true,
            "responseType": 'danger',
            "header": "Unable to login your facebook",
            "message": "unable-to-login-facebook"
          });
        }
      } catch (e) {
        commit('setLoading', false, {root: true})
        commit('setServerSideResponse', {
          "hasResponse": true,
          "responseType": 'danger',
          "header": "Unable to login",
          "message": "unable-to-login-facebook"
        });
      }
    },
  },
  getters: {
    user: state => state.user,
    serverSideResponse: state => state.serverSideResponse,
    loginForm: state => state.loginForm,
    signUpForm: state => state.signUpForm,
    resetPasswordForm: state => state.resetPasswordForm,
    forgotPasswordForm: state => state.forgotPasswordForm,
    isLoggedIn: state => !_.isEmpty(state.user),
    notifications: state => state.userNotifications,
  }
}
